import type { PaletteColor } from '@hrms/shared'
import type { ReactNode } from 'react'
import type { IconType } from 'react-icons'
import { cn } from '../../lib/cn.ts'

export interface EmptyStateProps {
  icon?: IconType
  color?: PaletteColor
  title: string
  children?: ReactNode
  action?: ReactNode
  className?: string
}

export function EmptyState({
  icon: Icon,
  color = 'slate',
  title,
  children,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'rounded-panel border border-dashed border-border-strong bg-surface px-5 py-14 text-center',
        className,
      )}
    >
      {Icon && (
        <span
          data-color={color}
          aria-hidden
          className="mx-auto mb-3 flex size-12 items-center justify-center rounded-full bg-cb text-2xl text-cf"
        >
          <Icon />
        </span>
      )}
      <h3 className="text-base text-text">{title}</h3>
      {children && <p className="mx-auto mt-1 max-w-[46ch] text-muted">{children}</p>}
      {action && <div className="mt-3.5 flex justify-center">{action}</div>}
    </div>
  )
}
